export default {
    getName(state) {
        if (state.user)
            return state.user.name
    },

    getUser(state) {
        return state.user
    }
}
